module.exports = __webpack_public_path__ + "static/media/12.9488b524.png";